import axios from "axios";

const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://app.travelxoxo.io/api"    
    : "http://localhost:5000/api";

const API = axios.create({ baseURL: API_BASE_URL });

export default API;

// import axios from "axios";

// const API = axios.create({
//   baseURL: "https://app.travelxoxo.io/api"
// });

// export default API;
